import { APICore } from './apiCore';

const api = new APICore();

export interface PreferencePayload {
    preference_name: string;
    type: 'Text' | 'Image' | 'Video' | 'Document';
    text_preference?: string;
    preference_file?: File;
}

/* CREATE */
export function createPreference(data: any) {
    return api.create(`/preference/add`, data);
  }
  
/* LIST */
export function showPreferences() {
    return api.show('/preference/all');
}

/* DETAILS */
export function showPreferenceDetails(id: string) {
    return api.show(`/preference/${id}`);
}

/* DELETE */
export function deletePreference(id: string) {
    return api.delete(`/preference/${id}`);
}

/* UPDATE */
export function updatePreference(id: string, data: any) {
    return api.update(`/preference/${id}`, data);
  }
  
